import constants from '../../constants';

const getCustomColorFromTextColor = (textColor) => {
  const colorHash = textColor.split('-').pop();
  return `--${constants.CUSTOM_COLOR_CSS_VARIABLE}-${colorHash}`;
};

export default getCustomColorFromTextColor;
